import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/home";
import Connectors from "./pages/connectors";
import DataManagement from "./pages/dataManagement";
import AdvancedSecurity from "./pages/advancedSecurity";
import RealtimeData from "./pages/realtimeData";
import Reports from "./pages/reports";
import Partnerships from "./pages/partnerships";
import Awards from "./pages/awards";
import WhoWeAre from "./pages/whoWeAre";
import SecurityAndManagement from "./pages/securityAndManagement";
import WhiteLabel from "./pages/whiteLabel";
import InteractiveDashboards from "./pages/InteractiveDashboards";
import Modules from "./pages/modules";
import DevelopAndIntegrate from "./pages/developAndIntegrate";
import Form from "./pages/form";
import Retail from "./pages/retail";
import Financial from "./pages/financial";
import PublicSector from "./pages/publicSector";
import Industry from "./pages/industry";
import Education from "./pages/education";
import Health from "./pages/health";
import Ecommerce from "./pages/ecommerce";
import Telecom from "./pages/telecom";
import Example from "./pages/example";
import DataSources from "./pages/dataSources";
import PublishAndShare from "./pages/publishAndShare";
import Scheduling from "./pages/scheduling";

import AgileDashboards from "./pages/agileDashboards";

import SupportTickets from "./pages/tickets";
import ChatBotPage from "./pages/chatbot";
import DataProtection from "./pages/dataProtection";
import FinancialsOperations from "./pages/financialsOperational";

import PrivacyPolicy from "./pages/privacyAndTerms/privacyPolicy";
import TermsOfUse from "./pages/privacyAndTerms/termsOfUse";

function Routers() {
  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/connectors" element={<Connectors />} />
          <Route path="/DataManagement" element={<DataManagement />} />
          <Route path="/AdvancedSecurity" element={<AdvancedSecurity />} />
          <Route path="/RealtimeData" element={<RealtimeData />} />
          <Route path="/Reports" element={<Reports />} />
          <Route path="/Partnerships" element={<Partnerships />} />
          <Route path="/Awards" element={<Awards />} />
          <Route path="/WhoWeAre" element={<WhoWeAre />} />
          <Route
            path="/SecurityAndManagement"
            element={<SecurityAndManagement />}
          />
          <Route path="/WhiteLabel" element={<WhiteLabel />} />
          <Route
            path="/InteractiveDashboards"
            element={<InteractiveDashboards />}
          />
          <Route path="/Modules" element={<Modules />} />
          <Route
            path="/DevelopAndIntegrate"
            element={<DevelopAndIntegrate />}
          />
          <Route path="/Form" element={<Form />} />
          <Route path="/Retail" element={<Retail />} />
          <Route path="/Financial" element={<Financial />} />
          <Route path="/PublicSector" element={<PublicSector />} />
          <Route path="/Industry" element={<Industry />} />
          <Route path="/Education" element={<Education />} />
          <Route path="/Health" element={<Health />} />
          <Route path="/Ecommerce" element={<Ecommerce />} />
          <Route path="/Telecom" element={<Telecom />} />
          <Route path="/Example" element={<Example />} />
          <Route path="/DataSources" element={<DataSources />} />
          <Route path="/PublishAndShare" element={<PublishAndShare />} />
          <Route path="/scheduling" element={<Scheduling />} />
          <Route path="/SupportTickets" element={<SupportTickets />} />
          <Route path="/DataProtection" element={<DataProtection />} />
          <Route
            path="/FinancialsOperational"
            element={<FinancialsOperations />}
          />

          <Route path="/PrivacyPolicy" element={<PrivacyPolicy />} />
          <Route path="/TermsOfUse" element={<TermsOfUse />} />

          <Route path="/AgileDashboards" element={<AgileDashboards />} />
          <Route path="/Chatbot" element={<ChatBotPage />} />

          <Route path="*" element={<Home />} />
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default Routers;
